// IT2104FieldMappings.js

/**
 * Field mappings for IT-2104 form
 * Coordinates are based on a PDF with dimensions 612 x 792 points (8.5" x 11")
 * Origin (0,0) is at bottom-left corner
 * All coordinates precisely matched to form alignment
 */

export const getFormattedDate = () => {
    const today = new Date();
    return `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
  };
  
  export const DEFAULT_ADMIN_DATA = {
    ein: '',
    isNewHire: true,
    hasBenefits: false,
    firstDateOfService: getFormattedDate()
  };

export const IT2104FieldMappings = {
    // Personal Information Section - Line 1
    firstName: {
      type: 'text',
      page: 0,
      x: 60,     
      y: 685,  
      maxWidth: 150,
      fontSize: 10
    },
    middleInitial: {
      type: 'text',
      page: 0,
      x: 155,  
      y: 685,
      maxWidth: 20,
      fontSize: 10
    },
    lastName: {
      type: 'text',
      page: 0,
      x: 290,  
      y: 685,
      maxWidth: 150,
      fontSize: 10
    },
    ssn: {
      type: 'text',
      page: 0,
      x: 500,  
      y: 685,
      maxWidth: 100,
      fontSize: 10
    },
    // Additional Withholding Fields (Lines 3, 4, 5)
additionalNYSAmount: {
  type: 'text',
  page: 0,
  x: 515,  // Adjust x position based on PDF alignment
  y: 542,  // Adjust y position based on PDF alignment
  maxWidth: 80,
  fontSize: 10
},
additionalNYCAmount: {
  type: 'text',
  page: 0,
  x: 515,
  y: 530,
  maxWidth: 80,
  fontSize: 10
},
additionalYonkersAmount: {
  type: 'text',
  page: 0,
  x: 515,
  y: 518,
  maxWidth: 80,
  fontSize: 10
},

    // Address Section - Line 2
    address: {
      type: 'text',
      page: 0,
      x: 85,     // Aligned with first name
      y: 660,    // Adjusted for proper spacing
      maxWidth: 300,
      fontSize: 10
    },
    apartmentNumber: {
      type: 'text',
      page: 0,
      x: 450,    // Moved right for proper alignment
      y: 845,
      maxWidth: 50,
      fontSize: 10
    },

    // City/State/ZIP - Line 3
    city: {
      type: 'text',
      page: 0,
      x: 85,     // Aligned with address
      y: 638,    // Adjusted for line spacing
      maxWidth: 200,
      fontSize: 10
    },
    state: {
      type: 'text',
      page: 0,
      x: 340,    // Adjusted for proper spacing
      y: 638,
      maxWidth: 30,
      fontSize: 10
    },
    zipCode: {
      type: 'text',
      page: 0,
      x: 390,    // Adjusted to follow state
      y: 638,
      maxWidth: 80,
      fontSize: 10
    },
  
    // Residency Checkboxes
    nycResident: {
      type: 'checkbox',
      page: 0,
      x: 528,    // Moved right to align with checkbox
      y: 625,    // Adjusted for proper line
      size: 12
    },
    yonkersResident: {
      type: 'checkbox',
      page: 0,
      x: 527,
      y: 612,    // Adjusted for spacing
      size: 12
    },
  
    // Marital Status Radio Buttons
    maritalStatus: {
      single: {
        type: 'checkbox',
        page: 0,
        x: 515,
        y: 670,    // Adjusted for proper line
        size: 18
      },
      married: {
        type: 'checkbox',
        page: 0,
        x: 563,
        y: 670,    // Adjusted spacing
        size: 18
      },
      marriedWithholdHigher: {
        type: 'checkbox',
        page: 0,
        x: 563,
        y: 660,    // Adjusted spacing
        size: 18
      }
    },
  
    // Allowances
    stateAllowances: {
      type: 'text',
      page: 0,
      x: 515,    // Aligned with right side
      y: 590,
      maxWidth: 30,
      fontSize: 10
    },
    cityAllowances: {
      type: 'text',
      page: 0,
      x: 515,
      y: 577,
      maxWidth: 30,
      fontSize: 10
    },
  
    // Additional Withholding
    additionalNYSAmount: {
      type: 'text',
      page: 0,
      x: 515,
      y: 542,
      maxWidth: 80,
      fontSize: 10
    },
    additionalNYCAmount: {
      type: 'text',
      page: 0,
      x: 515,
      y: 530,
      maxWidth: 80,
      fontSize: 10
    },
    additionalYonkersAmount: {
      type: 'text',
      page: 0,
      x: 515,
      y: 518,
      maxWidth: 80,
      fontSize: 10
    },
  
    // Signature
    signature: {
      type: 'image',
      page: 0,
      x: 105,
      y: 450,
      width: 200,
      height: 15
    },
    date: {
      type: 'text',
      page: 0,
      x: 500,
      y: 450,
      maxWidth: 80,
      fontSize: 10
    },
    employerInfo: {
        employerName: {
          type: 'text',
          page: 0,
          x: 85,
          y: 150,
          maxWidth: 300,
          fontSize: 10
        },
        employerAddress: {
          type: 'text',
          page: 0,
          x: 85,
          y: 135,
          maxWidth: 300,
          fontSize: 10
        },
        ein: {
          type: 'text',
          page: 0,
          x: 450,
          y: 150,
          maxWidth: 150,
          fontSize: 10
        }
      },
  
      // Employee Status Section
      employeeStatus: {
        over14Allowances: {
          type: 'checkbox',
          page: 0,
          x: 515,
          y: 115,
          size: 12
        },
        isNewHire: {
          type: 'checkbox',
          page: 0,
          x: 515,
          y: 100,
          size: 12
        },
        firstDateOfService: {
          type: 'text',
          page: 0,
          x: 450,
          y: 100,
          maxWidth: 100,
          fontSize: 10
        },
        hasBenefits: {
          type: 'checkbox',
          page: 0,
          x: 515,
          y: 85,
          size: 12
        },
        benefitsDate: {
          type: 'text',
          page: 0,
          x: 450,
          y: 85,
          maxWidth: 100,
          fontSize: 10
        }
      },

      adminFields: {
        ein: {
          type: 'text',
          page: 0,
          x: 515,
          y: 175,
          maxWidth: 150,
          fontSize: 10
        },
        isNewHireBox: {
          type: 'checkbox',
          page: 0,
          x: 186,    // Adjust based on your form
          y: 307,
          size: 12
        },
        noBenefitsBox: {  // Box for "No" on benefits
          type: 'checkbox',
          page: 0,
          x: 450,    // Adjust based on your form
          y: 242,
          size: 18
        }
    }
};

// Utility function remains the same
export const fillPDFForm = async (pdfDoc, formData, signatureImage) => {
    const pages = pdfDoc.getPages();
    const page = pages[0];
  
    // Fill regular form fields
    Object.entries(formData).forEach(([fieldName, value]) => {
      const mapping = IT2104FieldMappings[fieldName];
      if (!mapping) return;
  
      if (mapping.type === 'text') {
        page.drawText(value.toString(), {
          x: mapping.x,
          y: mapping.y,
          size: mapping.fontSize,
          maxWidth: mapping.maxWidth
        });
      } else if (mapping.type === 'checkbox' && value === true) {
        page.drawText('X', {
          x: mapping.x,
          y: mapping.y,
          size: mapping.size
        });
      }
    });
  
    // Handle marital status
    const maritalStatusMapping = IT2104FieldMappings.maritalStatus[formData.maritalStatus];
    if (maritalStatusMapping) {
      page.drawText('X', {
        x: maritalStatusMapping.x,
        y: maritalStatusMapping.y,
        size: maritalStatusMapping.size
      });
    }
  
    // Add signature if provided
    if (signatureImage) {
      const signatureMapping = IT2104FieldMappings.signature;
      const img = await pdfDoc.embedPng(signatureImage);
      page.drawImage(img, {
        x: signatureMapping.x,
        y: signatureMapping.y,
        width: signatureMapping.width,
        height: signatureMapping.height
      });
    }
  
    // Add current date
    const dateMapping = IT2104FieldMappings.date;
    page.drawText(getFormattedDate(), {
      x: dateMapping.x,
      y: dateMapping.y,
      size: dateMapping.fontSize
    });
  
    // Fill admin data
    const adminFields = IT2104FieldMappings.adminFields;
  
    // Fill EIN
    page.drawText(DEFAULT_ADMIN_DATA.ein, {
      x: adminFields.ein.x,
      y: adminFields.ein.y,
      size: adminFields.ein.fontSize,
      maxWidth: adminFields.ein.maxWidth
    });
  
    // Mark new hire checkbox
    if (DEFAULT_ADMIN_DATA.isNewHire) {
      page.drawText('X', {
        x: adminFields.isNewHireBox.x,
        y: adminFields.isNewHireBox.y,
        size: adminFields.isNewHireBox.size
      });
    }

    
  
    // Mark "No" for benefits
    if (!DEFAULT_ADMIN_DATA.hasBenefits) {
      page.drawText('X', {
        x: adminFields.noBenefitsBox.x,
        y: adminFields.noBenefitsBox.y,
        size: adminFields.noBenefitsBox.size
      });
    }
  
    return pdfDoc;
  };